import { render, staticRenderFns } from "./Island6.vue?vue&type=template&id=6635c4d8"
import script from "./Island6.vue?vue&type=script&lang=js"
export * from "./Island6.vue?vue&type=script&lang=js"
import style0 from "./Island6.vue?vue&type=style&index=0&id=6635c4d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports